<template>
  <div class="checklist-block-iqos-body-block gap-row-xs assign-block">
    <div class="gap-column-1xs">
      <div class="qrw-label-lg w-100 bold qrw-text-content-base-primary">
       {{ $t('checklist_blocks.settings.assign_title')  }}
      </div>
      <BaseToggleSwitcher fillBg="background-success-default" v-model="enabled" />
    </div>
    <div v-if="enabled">
      <BasePushButton
        @click="showModal"
        variant="stroke"
        size="md"
        icon="plus"
        hoverColor="content-base-inverse-primary"
        bgColor="background-base-inverse-primary"
        class="assign-button"
        v-if="!assignedId || !assignedOption"
      >
        {{ $t('checklist_blocks.settings.assign_add') }}
      </BasePushButton>
      <div class="assigned-option qrw-box-shadow-1dp" v-else>
        <div class="qrw-label-md bold qrw-text-content-base-primary option-group-item w-100">
          {{ assignedOption.text }}
        </div>
        <div class="qrw-label-md qrw-text-content-base-secondary option-group-item w-100">
          {{ assignedOption.group }}
        </div>
        <BaseIconButton
          variant="ghost"
          size="sm"
          icon="unlink"
          @click="assignOption(null)"
        />
      </div>
    </div>

    <WhiteModal
      hideFooter
      useTopPortal
      :title="$t('checklist_blocks.settings.assign_add') "
      v-if="adding"
      @close="adding = false"
    >
      <div class="gap-row-xs">
        <BaseSearchInput size="md" v-model="search" :placeholder="$t('checklist_blocks.settings.assign_search') " />

        <div
          class="option-group"
          v-for="(group, index) in groupedOptions"
          :key="index"
        >
          <div
            class="qrw-label-md bold qrw-text-content-base-primary option-group-name"
          >
            {{ group.group_name }}
          </div>
          <div
            @click="assignOption(item.option_id)"
            class="option-item qrw-label-md"
            v-for="item in group.items"
            :key="item.option_id"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </WhiteModal>
  </div>
</template>

<script>
export default {
  props: {
    block: Object,
    optionsBlocks: Array
  },
  data() {
    return {
      enabled: false,

      search: null,

      adding: false,
    };
  },
  computed: {
    allOptions() {
      return this.optionsBlocks
        .filter((b) => b.type === "OPTIONS")
        .reduce((acc, block) => {
          return acc.concat(
            block.options.rows.map((r) => ({
              text: r.text,
              group: block.title || "-",
              id: r.option_id,
            }))
          );
        }, []);
    },
    groupedOptions() {
      return this.optionsBlocks
        .filter((b) => b.type === "OPTIONS")
        .map((b, idx) => ({
          group_name: b.title || `#${idx}`,
          items: b.options.rows,
        })).filter(g => {
          if (!this.search) return true;

          return g.group_name.toLowerCase().includes(this.search.toLowerCase());
        });
    },
    form() {
      return this.$store.state.checklists.form;
    },
    assignedId() {
      return this.block.dependency_option_id;
    },
    assignedOption() {
      return this.allOptions.find((opt) => opt.id === this.assignedId);
    },
  },
  methods: {
    showModal() {
      this.adding = true;
    },
    assignOption(id) {
      this.$set(this.block, "dependency_option_id", id);

      this.adding = false;
      this.$emit('assigned');
    },
  },
  mounted() {
    if (this.assignedId) {
      this.enabled = true;
    }
  },
};
</script>

<style scoped>
.assign-button {
  width: fit-content;
}

.option-item {
  padding: 10px 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.option-group-name {
  padding: 10px 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.option-item:hover {
  font-weight: bold;
  background: var(--qrw-background-base-secondary);
}

.option-group {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 8px;
  border: 1px solid var(--qrw-border-base-secondary);
  border-radius: 12px;
}

.option-group-item {
  display: flex;
  align-items: center;
}

.assigned-option {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  padding: 4px;
  padding-left: 16px;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
   background: var(--qrw-background-base-primary);
}

.assign-block {
  background: var(--qrw-background-base-secondary);
}
</style>
